import { ContentBrick } from '../../app-kit/components/ContentBrick/ContentBrick';
import type { FunctionComponent, PropsWithChildren } from 'react';

import { DisclaimerIcon } from '../../app-kit/components/DisclaimerIcon/DisclaimerIcon';
import { trackDisclaimerModalOpen } from '../../analytics/event-tracking/trackDisclaimerModalOpen';

interface Modal {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  name: any;
}

interface NearbyChildcareCentresBrick {
  title: string;
  subtitle: string;
  pageSource: string;
  displayModal: (x: Modal) => void;
}

export const NearbyChildcareCentresBrick: FunctionComponent<
  PropsWithChildren<NearbyChildcareCentresBrick>
> = ({ title, subtitle, children, pageSource, displayModal }) => {
  return (
    <ContentBrick
      title={title}
      subtitle={subtitle}
      headerChildren={
        <DisclaimerIcon
          title="Open Nearby Childcare Disclaimer"
          onClick={() => {
            displayModal({ name: 'nearbyChildcareDisclaimer' });
            trackDisclaimerModalOpen({
              inPageSource: `${pageSource}__nearby_childcare_brick___disclaimer_button`,
            });
          }}
        />
      }
    >
      {children}
    </ContentBrick>
  );
};
